// import React from 'react';
// import loadable from '@loadable/component';

// const Insights = (props) => {
//   const Component = loadable(() => import('./Insights.js'), { ssr: false });
//   return <Component {...props} />;
// };

// export default Insights;

import React, { useRef, useState } from 'react';
import clsx from 'clsx';
import './style.scss';
import Item from './Item';
import { withTranslation } from 'react-i18next';
import { Swiper } from 'swiper/react/swiper-react.js';
import { Pagination } from 'swiper';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';

const rightArrow = '/-/media/Project/FAB2/Fab2/data/media/svgs/gallery/icon-arrow-right';
const leftArrow = '/-/media/Project/FAB2/Fab2/data/media/svgs/gallery/icon-arrow-left';

const Insights = ({ fields = {}, params, i18n }) => {
  const { heading, text, items } = fields;

  const shouldRenderHeading = !!heading?.value;
  const shouldRenderText = !!text?.value;
  const shouldRenderItems = Array.isArray(items) && items.length > 0;

  const swiperRef = useRef();

  const pagination = {
    clickable: true,
    renderBullet: function (_, className) {
      return '<span class="custom-pagination-cardlisting ' + className + '"></span>';
    },
  };
  const onSwap = (_, isFirst, isLast) => {
    setPrevDisabled(isFirst);
    setNextDisabled(isLast);
  };

  const handleSwap = (swiper) => {
    if (!onSwap) return;
    if (swiper?.pagination?.bullets?.length) {
      onSwap(swiper.pagination.bullets.length, swiper.isBeginning, swiper.isEnd);
    } else {
      onSwap(1, true, true);
    }
  };

  const [nextDisabled, setNextDisabled] = useState(false);
  const [prevDisabled, setPrevDisabled] = useState(true);

  return (
    <div className={clsx('insights-component content', 'add-margins', params?.Styles)}>
      {shouldRenderItems && (
        <>
          {params?.carouselMode !== '1' && (
            <>
              {(shouldRenderHeading || shouldRenderText) && shouldRenderHeading && (
                <div className="insights-heading d-none d-sm-flex">
                  <div className="heading-content">
                    <Text field={heading} />
                  </div>

                  {shouldRenderText && <RichText className="sub-heading-content" field={text} />}
                </div>
              )}
              <div className="row insights-content d-none d-sm-flex">
                {items.map((item, index) => {
                  return <Item key={index} data={item?.fields} i18n={i18n} />;
                })}
              </div>
            </>
          )}
          <div
            className={clsx(
              'insights-heading with-carousel',
              params?.carouselMode !== '1' && 'd-sm-none'
            )}
          >
            {shouldRenderHeading && (
              <div className="heading-content">
                <Text field={heading} />
              </div>
            )}
            <div className="heading-navigation">
              {shouldRenderText && <RichText className="sub-heading-content" field={text} />}
              <div className={clsx('custom-component-slider-controls navigation-custom')}>
                <div
                  role="button"
                  onClick={() => swiperRef.current.swiper.slidePrev()}
                  className={clsx(
                    'custom-component-slider-control',
                    prevDisabled && 'disabled-control'
                  )}
                >
                  <img src={leftArrow} alt="arrow" />
                </div>
                <div
                  role="button"
                  onClick={() => swiperRef.current.swiper.slideNext()}
                  className={clsx(
                    'custom-component-slider-control right-control',
                    nextDisabled && 'disabled-control'
                  )}
                >
                  <img src={rightArrow} alt="arrow" />
                </div>
              </div>
            </div>
          </div>
          <div
            className={clsx(
              'swiper-wrapper-custom',
              params?.carouselMode !== '1' && 'd-block d-sm-none'
            )}
          >
            <Swiper
              dir={i18n.language === 'en' ? 'ltr' : 'rtl'}
              ref={swiperRef}
              modules={[Pagination]}
              spaceBetween={9}
              breakpoints={{
                576: {
                  spaceBetween: 0,
                },
              }}
              pagination={pagination}
              onSlideChange={handleSwap}
              onPaginationRender={handleSwap}
              slidesPerView={'auto'}
              freeMode={true}
              className="insights-content row swiper-custom"
            >
              {items.map((item, index) => {
                return <Item key={index} data={item?.fields} i18n={i18n} swiperSlide={true} />;
              })}
            </Swiper>
          </div>
        </>
      )}
    </div>
  );
};

export default withTranslation()(Insights);
